/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    displayName?: string;
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    emailAddress?: string;
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    avatarUrl?: string;
}

/**
 * Check if a given object implements the UserInfo interface.
 */
export function instanceOfUserInfo(value: object): value is UserInfo {
    return true;
}

export function UserInfoFromJSON(json: any): UserInfo {
    return UserInfoFromJSONTyped(json, false);
}

export function UserInfoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UserInfo {
    if (json == null) {
        return json;
    }
    return {
        displayName:
            json["displayName"] == null ? undefined : json["displayName"],
        emailAddress:
            json["emailAddress"] == null ? undefined : json["emailAddress"],
        avatarUrl: json["avatarUrl"] == null ? undefined : json["avatarUrl"],
    };
}

export function UserInfoToJSON(value?: UserInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        displayName: value["displayName"],
        emailAddress: value["emailAddress"],
        avatarUrl: value["avatarUrl"],
    };
}
